export const marketPath = market =>
  market?.slug?.current
    ? `/${market?.slug?.current}/marktseite`
    : `/${market?.slug}/marktseite`

export const marketOfferPath = market =>
  market?.slug?.current
    ? `/${market?.slug?.current}/angebote`
    : `/${market?.slug}/angebote`

export const offerPreviewPath = market =>
  market?.slug?.current
    ? `/${market?.slug?.current}/angebotsvorschau`
    : `/${market?.slug}/angebotsvorschau`

export const lunchPath = market =>
  market?.slug?.current
    ? `/${market?.slug?.current}/mittagsgerichte`
    : `/${market?.slug}/mittagsgerichte`
